import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { labelledBoxStyles } from "../../../../../../styles/muiProps";
import AddIcon from "@mui/icons-material/Add";

import MoveUpIcon from "@mui/icons-material/MoveUp";
import DocTransmittalForm from "./Form";
import { useDocTransmittalContext } from "./DocTransmittal.context";
import DocTransmittalTabs, { DocTransmittalTabsPanels } from "./Tabs";

export default function DocTransmittalMain() {
  const { tab, onCLickAddNew } = useDocTransmittalContext();

  return (
    <div>
      <Box sx={{ ...labelledBoxStyles }}>
        <Box display="flex" alignItems="center" style={{ gap: "16px" }}>
          <Typography variant="h6">
            {" "}
            <MoveUpIcon
              sx={{ color: "#5D4108FF", mr: 1, transform: "translateY(5px)" }}
            />{" "}
            Document Transmittal
          </Typography>

          <DocTransmittalTabs />

          <Button
            variant={tab === "form" ? "contained" : "outlined"}
            startIcon={<AddIcon />}
            onClick={onCLickAddNew}
          >
            Add New
          </Button>
        </Box>
      </Box>

      {tab === "form" ? <DocTransmittalForm /> : <DocTransmittalTabsPanels />}
    </div>
  );
}
